export default __webpack_public_path__ + "static/media/2295.997abf57.png";